import { DtDropSelect } from '@ow/ditto-core'

const { config } = DtDropSelect

export { default as Render } from './render'
export { config }
